// src/components/Sidebar.tsx
import { Fragment } from "react";
import { Disclosure } from "@headlessui/react";
import {
  Home,
  ShoppingCart,
  BarChart,
  Users,
  Megaphone,
  Settings,
  Plug,
  HelpCircle,
  List,
  ChevronDown,
} from "lucide-react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const links = [
    {
      title: "Dashboard",
      icon: <Home size={18} />,
      to: "/dashboard",
    },
    {
      title: "Orders",
      icon: <ShoppingCart size={18} />,
      children: [
        { title: "Order Management", to: "/dashboard/orders" },
        { title: "Order History", to: "/dashboard/orders/history" },
      ],
    },
    {
      title: "Menu",
      icon: <List size={18} />,
      children: [
        { title: "View Menu", to: "/dashboard/menu" },
        { title: "Upload New Item", to: "/dashboard/menu-upload" },
        { title: "Modifiers", to: "/dashboard/menu/modifiers" },
        { title: "Pricing", to: "/dashboard/menu/pricing" },
      ],
    },
    {
      title: "Reports",
      icon: <BarChart size={18} />,
      children: [
        { title: "Performance", to: "/dashboard/analytics" },
        { title: "Financial Statements", to: "/dashboard/financials" },
      ],
    },
    {
      title: "Customers",
      icon: <Users size={18} />,
      children: [
        { title: "Customer Insights", to: "/dashboard/customers/insights" },
        { title: "Ratings & Reviews", to: "/dashboard/customers/ratings" },
        { title: "Loyalty Program", to: "/dashboard/customers/loyalty" },
      ],
    },
    {
      title: "Store",
      icon: <Settings size={18} />,
      children: [
        { title: "Store Info", to: "/dashboard/store/info" },
        { title: "Hours & Closures", to: "/dashboard/store/hours" },
        { title: "Bank & Payouts", to: "/dashboard/store/payouts" },
        { title: "Manage Users", to: "/dashboard/store/users" },
        { title: "Communications", to: "/dashboard/store/communications" },
      ],
    },
    {
      title: "Marketing",
      icon: <Megaphone size={18} />,
      to: "/dashboard/marketing",
    },
    {
      title: "Integrations",
      icon: <Plug size={18} />,
      to: "/dashboard/integrations",
    },
    {
      title: "Help & Support",
      icon: <HelpCircle size={18} />,
      to: "/dashboard/support",
    },
  ];

  return (
    <aside className="w-64 bg-[#1a1a1a] text-white p-6 overflow-y-auto flex-shrink-0">
      <div className="text-2xl font-bold mb-10">FullPlateNow</div>
      <nav className="space-y-2">
        {links.map((item, i) =>
          item.children ? (
            <Disclosure key={i} as="div" className="space-y-1">
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex justify-between items-center w-full text-left px-2 py-2 rounded hover:bg-[#2a2a2a]">
                    <span className="flex gap-2 items-center">
                      {item.icon}
                      {item.title}
                    </span>
                    <ChevronDown
                      className={`${
                        open ? "rotate-180" : ""
                      } h-4 w-4 transition-transform`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pl-7 space-y-1">
                    {item.children.map((sub, j) => (
                      <Link
                        key={j}
                        to={sub.to}
                        className="block py-1 text-sm text-gray-300 hover:text-white"
                      >
                        {sub.title}
                      </Link>
                    ))}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ) : (
            <Link
              key={i}
              to={item.to}
              className="flex items-center gap-2 px-2 py-2 rounded hover:bg-[#2a2a2a]"
            >
              {item.icon}
              {item.title}
            </Link>
          )
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
